import { connect } from 'react-redux';

import { notify } from 'app/developer-v3/store/shared/actions';

import DeployKeys from './DeployKeys';

const mapDispatchToProps = dispatch => ({
  notify: ({ isSuccess, message }: { isSuccess: boolean; message: string }) => {
    dispatch(notify[isSuccess ? 'success' : 'failure'](message));
  },
});

export default connect(undefined, mapDispatchToProps)(DeployKeys);
